'use strict';

angular
    .module('directives.selfAccessRequestDecision')
    .controller('selfAccessRequestDecisionItemController',
         ['$scope', '$state', 'selfAccessRequestService',
function ($scope, $state, selfAccessRequestService) {

        // Attach Decision
        selfAccessRequestService
            .getSelfAccessRequestLookups()
            .then(function (progressStepDecisions) {
                $scope.typeOfDecisions = _.filter(progressStepDecisions.ProgressStepDecisions, {
                    SelfAccessRequestProcessStepID: $scope.model.SelfAccessRequestProcessStepID
                });
                attachDecision($scope.model);
            });

        $scope.updateDecision = function () {
            findNextDecisionID($scope.model, $scope.model.Decision.NextAction);
        }

        // Go Back
        $scope.goBack = function () {
            $state.go('event', {eventGroupId: null}, {reload: true});
        };

        function attachDecision(decision) {
            selfAccessRequestService.getSelfAccessRequestLookups()
                .then(function (progressStepDecisions) {
                    var decisionToAttach = _.find(progressStepDecisions.ProgressStepDecisions, {
                        SelfAccessRequestProcessStepID: decision.SelfAccessRequestProcessStepID,
                        SelfAccessRequestProcessStepDecisionID: decision.SelfAccessRequestProcessStepDecisionID,
                    });
                    decision.Decision = decisionToAttach;
                });
        }

        function findNextDecisionID(selfAccessRequestProcessDecision, nextAction) {
            selfAccessRequestService.getSelfAccessRequestLookups()
                .then(function (progressStepDecisions) {
                    var decision = _.find(progressStepDecisions.ProgressStepDecisions, {
                        SelfAccessRequestProcessStepID: selfAccessRequestProcessDecision.Decision.SelfAccessRequestProcessStepID,
                        Decision: nextAction
                    });
                    selfAccessRequestProcessDecision.SelfAccessRequestProcessStepDecisionID = decision.SelfAccessRequestProcessStepDecisionID;
                    selfAccessRequestService
                        .updateUserSystemRoleDecision(selfAccessRequestProcessDecision.UserAccessRequestID,
                            selfAccessRequestProcessDecision.UserSystemRoleDecisionID,
                            selfAccessRequestProcessDecision)
                        .then(function (decision) {
                            _.assign($scope.model, decision);
                            attachDecision($scope.model);
                        }).then(function () {
                            $scope.onUpdate(decision);
                        })
                });
        }
    }]);